import React, { Component } from 'react';
import axios from 'axios'
import { Tree, message, Modal, Input, Button, Popconfirm, Tag } from 'antd';
const BASEAPI = ''




const statusMap = {
    'toUpload': '待上传',
    'toAudit': '待审核',
    'returnAudit': '补充审核',
    // 'uploaded': '已上传',
    'uploaded': ''
}

const statusMapColor = {
    'toUpload': '',
    'toAudit': 'volcano',
    'returnAudit': 'gold',
    // 'uploaded': '已上传',
    'uploaded': ''
}


const { TreeNode } = Tree;


class materialsTreeData extends Component {
    state = {
        // expandedKeys: [],
        autoExpandParent: true,
        checkedKeys: [],
        selectedKeys: [],
        // treeData: treeData
        treeData: [],
        visible: false,
        reason: '',
        secondTypeValue: '',
        isQualified: '',
        label: '',
    };
    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        const { from } = this.props

        const { treeData, secondTypeValue, isQualified, reason } = this.state

        if (from && from === 'loss-center') {
            return

        }
        const firstTypeValue = treeData.find(item => item.secondTypes.find(secondType => secondType.value === secondTypeValue)).value

        axios({
            method: 'post',
            url: `${BASEAPI}/api/lossAss/report/materialsAudit`,
            data: {
                flowId: this.props.flowId,
                agentId: this.props.agentId,
                firstTypeValue,
                secondTypeValue,
                toQualify: isQualified,
                reason,
            }
        }).then(response => {
            if (response.data.errCode === 0) {
                this.getTreeData()
                this.setState({
                    visible: false,
                });

            } else {
                message.error(response.data.errInfo)
            }

        }).catch(error => {

        })

    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    onExpand = expandedKeys => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        // this.setState({
        //     expandedKeys,
        //     autoExpandParent: false,
        // });
    };

    onCheck = (checkedKeys, e) => {
        const { treeData } = this.state
        this.setState({ checkedKeys });

        const firstTypeValue = treeData.find(item => item.secondTypes.find(secondType => secondType.value === e.node.props.eventKey)).value

        axios({
            method: 'post',
            url: `${BASEAPI}/api/lossAss/report/materialsAudit/isRequired`,
            data: {
                flowId: this.props.flowId,
                agentId: this.props.agentId,
                firstTypeValue,
                secondTypeValue: e.node.props.eventKey,
                isRequired: e.checked

            }
        }).then(response => {
            if (response.data.errCode === 0) {
                message.success('操作成功')
                this.getTreeData()

            } else {
                message.error(response.data.errInfo)
            }

        }).catch(error => {

        })
    };

    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    };
    // renderTreeNodes = data =>
    //     data.map(item => {
    //         if (item.children) {
    //             return (
    //                 <TreeNode title={item.title} key={item.key} dataRef={item}>
    //                     {this.renderTreeNodes(item.children)}
    //                 </TreeNode>
    //             );
    //         }
    //         return <TreeNode key={item.key} {...item} />;
    //     });
    renderTreeNodes = data =>
        data.map(item => {
            if (item.secondTypes) {
                return (
                    <TreeNode
                        checkable={false}
                        disableCheckbox={true}
                        title={item.label}
                        key={item.value}
                        dataRef={item}>
                        {this.renderTreeNodes(item.secondTypes)}
                    </TreeNode>
                );
            }
            return (
                <TreeNode title={<div className='tree-leaf-container'>
                    <div>
                        {<span>{item.label}</span>}
                        {
                            statusMap[item.status] &&
                            <Tag style={{ marginLeft: 10 }} color={statusMapColor[item.status]}>{statusMap[item.status]}</Tag>
                        }
                        {/* {<span style={{ marginLeft: 10 }}>{statusMap[item.status]}</span>} */}
                    </div>
                    <div>
                        {<i className="iconfont icon-check-outlined"
                            onClick={() => this.changeStatus(item.value, item.isQualified === '2' ? undefined : '2', item.isRequired)}
                            style={{ marginLeft: 10, color: item.isQualified === '2' ? '#23CB36' : '#ccc' }} />
                        }
                        {<i className="iconfont icon-close-outlined"
                            onClick={() => this.changeStatus(item.value, item.isQualified === '1' ? undefined : '1', item.isRequired)}
                            style={{ marginLeft: 10, color: item.isQualified === '1' ? '#EF3C3C' : "#ccc" }} />
                        }
                        {<i className="iconfont icon-message"
                            onClick={() => this.showReasonModal(item.value, item.isQualified, item.reason, item.isRequired, item.label)}
                            style={{ marginLeft: 10, color: item.reason ? '#1890ff' : "#ccc" }} />
                        }
                    </div>



                </div>
                } key={item.value}  {...item} />
            );
        });

    changeStatus = (secondTypeValue, toQualify, isRequired) => {
        const { from } = this.props
        if (from && from === 'loss-center') {
            return

        }
        if (!toQualify) {
            return

        }
        if (!isRequired) {
            message.info('勾选后才能操作')
            return

        }


        const { treeData } = this.state
        const firstTypeValue = treeData.find(item => item.secondTypes.find(secondType => secondType.value === secondTypeValue)).value

        axios({
            method: 'post',
            url: `${BASEAPI}/api/lossAss/report/materialsAudit`,
            data: {
                flowId: this.props.flowId,
                agentId: this.props.agentId,
                firstTypeValue,
                secondTypeValue,
                toQualify
            }
        }).then(response => {
            if (response.data.errCode === 0) {
                message.success('操作成功')
                this.getTreeData()

            } else {
                message.error(response.data.errInfo)
            }

        }).catch(error => {

        })

    }
    showReasonModal = (value, isQualified, reason, isRequired, label) => {
        if (!isRequired) {
            message.info('勾选后才能操作')
            return

        }
        this.setState({
            secondTypeValue: value,
            isQualified,
            reason,
            label
        })
        this.showModal()

    }
    componentDidMount() {
        this.getTreeData()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        const { flowId } = this.props

        if (flowId !== nextProps.flowId) {
            this.getTreeData()
        }


    }
    //查询材料审核列表信息
    getTreeData = () => {
        axios.get(`${BASEAPI}/api/lossAss/report/materialsAudit`, {
            params: {
                flowId: this.props.flowId,
                agentId: this.props.agentId,
            }
        })
            .then(response => {
                const treeData = response.data.result
                // const checkedKeys = treeData.map(item => item.secondTypes).filter(secondType => secondType.isRequired)
                const checkedKeys = []
                treeData.forEach(element => {
                    element.secondTypes.forEach(secondType => {
                        if (secondType.isRequired) {
                            checkedKeys.push(secondType.value)
                        }

                    })
                });
                this.setState({
                    treeData,
                    checkedKeys
                })


            })
            .catch(error => {

            })
    }
    handleChangeReason = (e) => {
        this.setState({
            reason: e.target.value
        })

    }
    hideTreeData = () => {
        this.props.hideTreeData()
    }

    setAllQualify = () => {
        axios({
            method: 'post',
            url: `${BASEAPI}/api/lossAss/report/materialsAudit`,
            data: {
                flowId: this.props.flowId,
                agentId: this.props.agentId,
                isAll: '1',
                toQualify: '2'

            }
        }).then(response => {
            if (response.data.errCode === 0) {
                message.success('操作成功')
                this.getTreeData()

            } else {
                message.error(response.data.errInfo)
            }

        }).catch(error => {

        })

    }

    render() {
        const { treeData, reason } = this.state
        const { from } = this.props
        return (
            <div style={{ fontSize: 14 }}>
                {
                    this.props.hideTreeData
                    &&
                    <i className="iconfont icon-close-outlined"
                        onClick={this.hideTreeData}
                        style={{ fontSize: 20, position: 'absolute', right: 10, top: 10, zIndex: 5, cursor: 'pointer' }}></i>
                }

                <h3 style={{ fontSize: 14 }}>材料明细</h3>
                <p style={{ marginTop: 10, marginBottom: 10, fontSize: 14 }}>客户仅可见勾选的项,勾选项均为必传</p>
                <p>
                    <i className="iconfont icon-check-outlined" />&nbsp;<span style={{ fontSize: 14 }}>合格</span>&nbsp;&nbsp;
                    <i className="iconfont icon-close-outlined" />&nbsp;<span style={{ fontSize: 14 }}>不合格</span>&nbsp;&nbsp;
                    <i className="iconfont icon-message" />&nbsp;<span style={{ fontSize: 14 }}>不合格原因</span>&nbsp;&nbsp;
                    <Popconfirm
                        title="确定全部类别已合格?"
                        onConfirm={this.setAllQualify}

                        okText="确定"
                        cancelText="取消"
                    >
                        <Button
                            type="primary"
                            size='small'
                            disabled={from && from === 'loss-center'}
                        >全部合格</Button>
                    </Popconfirm>

                </p>
                {treeData.length > 0 ? <Tree
                    checkable
                    defaultExpandAll
                    onExpand={this.onExpand}
                    // expandedKeys={this.state.expandedKeys}
                    autoExpandParent={this.state.autoExpandParent}
                    onCheck={this.onCheck}
                    checkedKeys={this.state.checkedKeys}
                    onSelect={this.onSelect}
                    selectedKeys={this.state.selectedKeys}
                    disabled={from && from === 'loss-center'}

                >
                    {this.renderTreeNodes(treeData)}
                </Tree> : null}

                <Modal
                    title={this.state.label + ' 备注原因'}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}

                >
                    <Input.TextArea
                        placeholder='请输入；字段限制50字以内'
                        rows={4}
                        value={reason}
                        onChange={this.handleChangeReason}
                    />

                </Modal>

            </div>
        );
    }
}
export default materialsTreeData;